import { action } from 'typesafe-actions';
import { IIntegration } from 'types';
import { Integration } from './types';

export const getIntegrationRequest = (siteId: string, integrationId: string) => action(Integration.GET_INTEGRATION_REQUEST, { siteId, integrationId });
export const getIntegrationSucess = (response: IIntegration) => action(Integration.GET_INTEGRATION_SUCCESS, response);
export const getIntegrationError = (error: any) => action(Integration.GET_INTEGRATION_FAIL, error);
